module.exports = {
	PATH_SEPARATOR: '.',
	TARGET: Symbol('target'),
	UNSUBSCRIBE: Symbol('unsubscribe')
};
